'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconMenu = require('material-ui/IconMenu');

var _IconMenu2 = _interopRequireDefault(_IconMenu);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	anchorOrigin: _propTypes2.default.shape({
		horizontal: _propTypes2.default.string,
		vertical: _propTypes2.default.string
	}),
	children: _propTypes2.default.node,
	className: _propTypes2.default.string,
	iconButtonElement: _propTypes2.default.element.isRequired,
	iconStyle: _propTypes2.default.object,
	listStyle: _propTypes2.default.object,
	menuStyle: _propTypes2.default.object,
	style: _propTypes2.default.object,
	multiple: _propTypes2.default.bool,
	onItemClick: _propTypes2.default.func,
	onKeyboardFocus: _propTypes2.default.func,
	onMouseDown: _propTypes2.default.func,
	onMouseEnter: _propTypes2.default.func,
	onMouseLeave: _propTypes2.default.func,
	onMouseUp: _propTypes2.default.func,
	onRequestChange: _propTypes2.default.func,
	onClick: _propTypes2.default.func,
	open: _propTypes2.default.bool,
	targetOrigin: _propTypes2.default.shape({
		horizontal: _propTypes2.default.string,
		vertical: _propTypes2.default.string
	}),
	useLayerForClickAway: _propTypes2.default.bool
};

var getIcon = function getIcon(elem) {
	return _react2.default.createElement(_IconButton2.default, elem.props);
};

var WMIconMenu = function WMIconMenu(props) {
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(
			_IconMenu2.default,
			_extends({}, props, {
				iconButtonElement: getIcon(props.iconButtonElement)
			}),
			props.children
		)
	);
};

exports.default = WMIconMenu;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMIconMenu/index.js